import { useEffect, useState } from "react";

const useScreenSize = () => {
  const [isLessThanMd, setIsLessThanMd] = useState(window.innerWidth < 900);
  const [isGreaterThanOrEqualMd, setIsGreaterThanOrEqualMd] = useState(
    window.innerWidth >= 960
  );

  useEffect(() => {
    const handleResize = () => {
      setIsLessThanMd(window.innerWidth < 960);
      setIsGreaterThanOrEqualMd(window.innerWidth >= 960);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isLessThanMd, isGreaterThanOrEqualMd };
};

export default useScreenSize;
